
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gs9pyGeqPpSJqn2RUD0Jn4dsq2vmE4rtAjdxZd5Wy0O8Meta } from "/codebuild/output/src3753344215/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexpV_45KwrlJyj7TgxBNZBs3cv_kQTEBw1uLhY5ErK0vjnkMeta } from "/codebuild/output/src3753344215/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchDatoKm6t_EIXoyHYKIDpxjQ6z_45qRfndwRLG3_kdctY4Meta } from "/codebuild/output/src3753344215/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexKRC07U39Mf0st56fQdaHz6pKYc58A8kyAzqtLitLCYwMeta } from "/codebuild/output/src3753344215/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93kEg5WDaKR_45K_45YwTWSjpC8K2e6Udv_Fi9CiTYimqVBpgMeta } from "/codebuild/output/src3753344215/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexb8_LyskTmCMqC9XmWu44FlrU96uB_45Piyd8aiHl38i0kMeta } from "/codebuild/output/src3753344215/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93JMxk3skZWwVYbrsTyUnHcECd1ebiHvNmfSjBb_45BXVKwMeta } from "/codebuild/output/src3753344215/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexvYQ6BB1joHN8B5BZL1kIxsqpg5ryZM5ditvIKLdwbgYMeta } from "/codebuild/output/src3753344215/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93jmSC5sRcmbIXaEaPguTpaHY_zNYQPDcZnzGjuYIXSS0Meta } from "/codebuild/output/src3753344215/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexdKWk9d_45f4lGu3rTSA_Zf_45ULwb_45Z89LohTfBAcTHTFIkMeta } from "/codebuild/output/src3753344215/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexxcZ5UQGJzQh43nz9BkD_45iatXPhgXA1QY3vE7Lep44okMeta } from "/codebuild/output/src3753344215/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3753344215/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3753344215/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3753344215/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3753344215/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3753344215/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexb8_LyskTmCMqC9XmWu44FlrU96uB_45Piyd8aiHl38i0kMeta || {},
    component: () => import("/codebuild/output/src3753344215/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3753344215/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexvYQ6BB1joHN8B5BZL1kIxsqpg5ryZM5ditvIKLdwbgYMeta || {},
    component: () => import("/codebuild/output/src3753344215/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3753344215/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexdKWk9d_45f4lGu3rTSA_Zf_45ULwb_45Z89LohTfBAcTHTFIkMeta || {},
    component: () => import("/codebuild/output/src3753344215/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexxcZ5UQGJzQh43nz9BkD_45iatXPhgXA1QY3vE7Lep44okMeta || {},
    component: () => import("/codebuild/output/src3753344215/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]